import Head from 'next/head';
import PropTypes from 'prop-types';

export default function SeoJsonLdVideo({ post }) {
	return (
		<>
			{post?.featuredVideoDetails?.id && (
				<Head>
					<script
						type="application/ld+json"
						// eslint-disable-next-line react/no-danger
						dangerouslySetInnerHTML={{
							__html: `
					{
						"@context": "https://schema.org",
						"@type": "VideoObject",
						"description": "${post?.featuredVideoDetails?.description}",
						"duration": "PT${post?.featuredVideoDetails?.duration}S",
						"name": "${post?.featuredVideoDetails?.title}",
						"thumbnailUrl": "${post?.featuredVideoDetails?.thumbnailURL}",
						"uploadDate": "${post?.featuredVideoDetails?.publishedDate}"
					}`,
						}}
					/>
				</Head>
			)}
		</>
	);
}

SeoJsonLdVideo.propTypes = {
	post: PropTypes.shape({
		featuredVideoDetails: PropTypes.shape({
			id: PropTypes.string,
			title: PropTypes.string,
			description: PropTypes.string,
			thumbnailURL: PropTypes.string,
			publishedDate: PropTypes.string,
			duration: PropTypes.string,
		}),
	}).isRequired,
};
